import React, {Component} from 'react';
import {
    TopButtonAction, TopButtonCancel, TopButtonSave,
} from "../../../../componentsTopsa/buttons/TopButtons";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import SzablonyService from "../SzablonyService";
import {ButtonToolbar} from "react-bootstrap";
import ReactNotify from 'react-notify';
import Dropzone from "react-dropzone";
import OthersUtilities from "../../../../utilities/othersUtilities/OthersUtilities";

export default class SzablonyList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showModal: false,
            textFileForModal: null,
            textFileForModalInfo: null,
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatNazwaPliku = this.formatNazwaPliku.bind(this)
        this.onChangeTextFileInModal = this.onChangeTextFileInModal.bind(this)
        this.onClickConvertAndSaveTextFile = this.onClickConvertAndSaveTextFile.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.data)) {
            this.setState({data: this.props.data})
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.data)) {
            this.setState({data: nextprops.data})
        }
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <div>
                    <section className={'dropzoneSection'} style={{display: 'block'}}>
                        <div className="dropzone" style={{
                            border: '1px dotted #aaa',
                            borderRadius: '3px',
                            cursor: 'pointer',
                            width: '100%',
                            lineHeight: '34px',
                            padding: '0 10px',
                            textAlign: 'center',
                            fontSize: '12px'
                        }}>
                            <Dropzone onDrop={(file) => this.onDropPodmianaPliku(file, row)} style={{}} multiple={true}>
                                                    <span style={{display: 'inline-block'}}>
                                                         <span><i className={'fa fa-clipboard'}></i> Kliknij lub przeciągnij aby zaktualizować stary plik</span>
                                                    </span>
                            </Dropzone>
                        </div>
                    </section>
                </div>
            </div>
        )
    }

    onDropPodmianaPliku(file, object) {
        if (window.confirm('Czy na pewno chcesz zamienić plik w wpisie o nazwie ' + object.nazwa)) {

            if (file[0].size > 5252880) {
                alert('Rozmiar pliku jest za duży! Max 5MB')
            } else {
                const promise = new Promise((resolve, reject) => {
                    const reader = new FileReader()

                    reader.readAsDataURL(file[0])

                    reader.onload = () => {
                        if (!!reader.result) {
                            resolve(reader.result)
                        }
                        else {
                            reject(Error("Failed converting to base64"))
                        }
                    }

                })
                promise.then(result => {
                    // dispatch or do whatever you need with result

                    let przecinek = result.indexOf(',');
                    let skrocony = result.substr(przecinek + 1, result.length - 1)
                    let plik = {
                        "dane": skrocony,
                        "nazwa": file[0].name,
                        "typ": file[0].type,
                        "rozmiar": file[0].size,
                        "dokumentTyp": "STRONA_WPIS",
                        "dokumentId": object.id,
                        "opis": object.opis,
                        "slug": object.slug,
                        "dostep": 'PUBLIC'
                    }

                    SzablonyService.putSzablon(plik).then(function (response) {
                        if (response.status < 300) {
                            this.props.handleOdswiez();
                            this.refs.notificator.success('Pomyślnie podmienono na nowy plik', "", 3000)
                        }
                        else {
                            this.refs.notificator.error('Wystąpił błąd podczas próby podmiany pliku', "", 3000)
                        }
                    }.bind(this))

                }, err => {
                    console.log(err)
                    alert('Błąd przy próbie załadowania dokumentu')
                })
            }
        }
    }

    showLink(cell, row) {
        return <a href={row.link} target={'_blank'}>{row.slug} <i className="fa fa-external-link"/></a>
    }

    formatNazwaPliku(cell, row) {
        return (<div>
            {
                (cell.indexOf('.htm') > -1 || cell.indexOf('.txt') > -1) ?

                    <span style={{cursor: 'pointer'}} onClick={() => this.onClickEditTextFile(row)}>
                        <i className={OthersUtilities.renderFileIcon(row.typ)} style={{marginRight:'5px'}}></i> {cell}
                        <div className={'pull-right'}>
                        <span style={{color: 'grey', display: 'inline-block', marginLeft: '5px', fontSize: '20px'}}
                              title={'Edytuj plik tekstowy w edytorze'}><i className={'fa fa-edit'}></i></span>
                    </div>
                    </span>
                    :
                    <span><i className={OthersUtilities.renderFileIcon(row.typ)} style={{marginRight:'5px'}}></i> {cell}</span>
            }
        </div>)
    }

    onClickEditTextFile(obj) {
        SzablonyService.getContentOfFile(obj.link).then(function (response) {
            if (response) {
                let content = 'text/plain'
                if (response.headers['content-type'].indexOf('htm') > -1) {
                    content = 'text/html'
                }

                this.setState({
                    showModal: true,
                    textFileForModal: response.data,
                    textFileForModalInfo: [obj, content]
                })
            }
        }.bind(this))
    }

    onChangeTextFileInModal(e) {
        this.setState({textFileForModal: e.target.value})
    }

    onClickConvertAndSaveTextFile() {
        let textFile = new Blob([this.state.textFileForModal], {type: this.state.textFileForModalInfo[1]});
        const promise = new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.readAsDataURL(textFile)

            reader.onload = () => {
                if (!!reader.result) {
                    resolve(reader.result)
                }
                else {
                    reject(Error("Failed converting to base64"))
                }
            }

        })
        promise.then(result => {
            // dispatch or do whatever you need with result

            let przecinek = result.indexOf(',');
            let skrocony = result.substr(przecinek + 1, result.length - 1)
            let plik = {
                "dane": skrocony,
                "nazwa": this.state.textFileForModalInfo[0].nazwa,
                "typ": textFile.type,
                "rozmiar": textFile.size,
                "dokumentTyp": "STRONA_WPIS",
                "dokumentId": this.state.textFileForModalInfo[0].id,
                "opis": this.state.textFileForModalInfo[0].opis,
                "slug": this.state.textFileForModalInfo[0].slug,
                "dostep": 'PUBLIC'
            }

            SzablonyService.putSzablon(plik).then(function (response) {
                if (response.status < 300) {
                    this.props.handleOdswiez();
                    this.refs.notificator.success('Pomyślnie edytowano i zapisano plik', "", 3000)
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas próby zapisu pliku', "", 3000)
                }
                this.setState({showModal: false, textFileForModal: null, textFileForModalInfo: null})
            }.bind(this))

        }, err => {
            console.log(err)
            alert('Błąd przy próbie załadowania dokumentu')
        })

    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div>
                    <BootstrapTable data={this.state.data}
                                    options={options}
                                    pagination
                                    hover
                    >
                        <TableHeaderColumn dataField='id' isKey hidden={(this.state.filterPracownik === false) ? true : false} thStyle={tabgrid.tg1}
                                           tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='opis'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Opis</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatNazwaPliku}
                        >Nazwa pliku</TableHeaderColumn>
                        <TableHeaderColumn dataField='slug'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}} dataFormat={this.showLink.bind(this)}
                        >Ścieżka</TableHeaderColumn>
                        <TableHeaderColumn dataField='id'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           dataFormat={this.renderButtonyAkcji}
                        ></TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {
                    (Boolean(this.state.textFileForModalInfo) && this.state.showModal) ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'}>
                                <div id={'modalTextContent'} style={{width: '1000px'}}>
                                    <div>
                                        <div className={'pull-right'}>
                                            <TopButtonAction onClick={() => {
                                                this.setState({showModal: false, textFileForModal: null, textFileForModalInfo: null})
                                            }}
                                                             elementStyle={{color: 'firebrick'}}
                                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                            />
                                        </div>
                                        <div style={{clear: 'both'}}></div>
                                        <div>
                                            <h5>
                                                <span style={{fontWeight: 'bold'}}>{this.state.textFileForModalInfo[0].nazwa}</span>
                                            </h5>
                                            <textarea style={{height: '400px', width: '100%', maxWidth: '966px'}} className={'form-control'}
                                                      defaultValue={this.state.textFileForModal} onChange={this.onChangeTextFileInModal}
                                            >
                                        </textarea>
                                        </div>
                                        <div style={{marginTop: '15px'}}>
                                            <div className={'pull-right'}>
                                                <ButtonToolbar>
                                                    <TopButtonCancel onClick={() => {
                                                        this.setState({showModal: false, textFileForModal: null, textFileForModalInfo: null})
                                                    }}/>
                                                    <TopButtonSave
                                                        onClick={this.onClickConvertAndSaveTextFile}/>
                                                </ButtonToolbar>
                                            </div>
                                            <div style={{clear: 'both'}}></div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/szablony/components/SzablonyList.js